import { Dispatch, RefObject, SetStateAction } from 'react';

import { DestinationsMenu } from '../../../../../resources/destinationsMenu/domain/types/destinationsMenu';
import { HubDestinationMenu } from '../../../../../resources/hubDestinationMenu/domain/types/hubDestinationMenu';
import { NormalizedWhereToGoMenu } from '../../../../../resources/whereToGoMenu/api/prismic/normalizers';
import { PrimaryNavContextContinent, PrimaryNavValue } from '../../types';
import { CommitmentsMobileView } from '../View/Commitments/CommitmentsMobileView';
import { DestinationsMobileView } from '../View/Destinations/DestinationsMobileView';
import { HubDestinationMobileView } from '../View/HubDestination/HubDestinationMobileView';
import { NewWhereToGoMobileView } from '../View/NewWhereToGo/NewWhereToGoMobileView';

import style from './MobileMenu.module.css';

type Props = {
    navValue: PrimaryNavValue;
    contextContinent: PrimaryNavContextContinent | null;
    hubDestinationDropdown: HubDestinationMenu | null;
    destinationsMenu: DestinationsMenu | null;
    whereToGoMenu: NormalizedWhereToGoMenu | null;
    setNavValue: Dispatch<SetStateAction<PrimaryNavValue>>;
    onOpenSearchOverlay: () => void;
    searchTriggerRef: RefObject<HTMLButtonElement | null>;
};

export function MobileMenu({
    navValue,
    contextContinent,
    hubDestinationDropdown,
    destinationsMenu,
    whereToGoMenu,
    setNavValue,
    onOpenSearchOverlay,
    searchTriggerRef,
}: Props) {
    if (navValue === null || navValue === 'USER_ACCOUNT') {
        return null;
    }

    return (
        <div className={style.container}>
            {navValue === 'HUB_DESTINATION' && hubDestinationDropdown ? (
                <HubDestinationMobileView
                    hubDestinationMenu={hubDestinationDropdown}
                    setNavValue={setNavValue}
                />
            ) : null}

            {navValue === 'DESTINATIONS' && destinationsMenu ? (
                <DestinationsMobileView
                    setNavValue={setNavValue}
                    contextContinent={contextContinent}
                    destinationsMenu={destinationsMenu}
                />
            ) : null}

            {navValue === 'WHERE_TO_GO' && whereToGoMenu ? (
                <NewWhereToGoMobileView
                    whereToGoMenu={whereToGoMenu}
                    setNavValue={setNavValue}
                    onOpenSearchOverlay={onOpenSearchOverlay}
                    searchTriggerRef={searchTriggerRef}
                />
            ) : null}

            {navValue === 'COMMITMENTS_MOBILE' ? <CommitmentsMobileView /> : null}
        </div>
    );
}
